const { instance } = require('./url')
const { PurchaseOrder } = require('../PurchaseOrder')
const { PurchaseOrderItem } = require('../PurchaseOrderItem')

async function getPurchaseOrder(id) {
    return await instance.get('/purchase_order/purchase_order/' + id).then(
        (result) => {
            return PurchaseOrder.from(result.data.purchase_order)
        }
    )
}

async function createPurchaseOrder(purchaseOrder) {
    return await instance.post('/purchase_order/purchase_order', {
        'purchase_order': purchaseOrder
    }).then(
        (result) => {
            return PurchaseOrder.from(result.data.purchase_order)
        }
    )
}

async function updatePurchaseOrder(purchaseOrder) {
    return await instance.put('/purchase_order/purchase_order/' + purchaseOrder.id, {
        'purchase_order': purchaseOrder
    }).then(
        (result) => {
            return PurchaseOrder.from(result.data.purchase_order)
        }
    )
}

async function searchPurchaseOrders(search) {
    return await instance.post('/purchase_order/search/all', {
        'search': search
    }).then(
        (result) => {
            return result.data.purchase_orders.map((x) => {
                return PurchaseOrder.from(x)
            })
        }
    )
}

async function searchItems(description) {
    return await instance.post('/purchase_order/search/description', {
        'search': description
    }).then(
        (result) => {
            return result.data.items.map((item) =>
                PurchaseOrderItem.from(item)
            )
        }
    )
}

export {
    getPurchaseOrder,
    createPurchaseOrder,
    updatePurchaseOrder,
    searchPurchaseOrders,
    searchItems,
}

